import { reducer as allDeliveries } from "./deliveries/slice";

export const reducer = {
  allDeliveries,
};
